import axios from 'axios';

const baseURL = `api/frameselection`;

export default {
    // Returns LLT Characteristics for calculating measurements
    getMaterialsByParent(parentCharacteristic: string) {
        const token = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return axios.get(`${baseURL}?parentCharacteristicCode=${parentCharacteristic}`);
    },
    // Gets inital characteristics with main dependencie filtered
    getFrameCharacteristics(anchor: number, selectedValues: string) {
        const token = localStorage.getItem('token')
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return axios.get(`${baseURL}?anchor=${anchor}&selectedValues=${selectedValues}`);
    },
};